import functionlist from "./functionlist";

const CustomFormatter = () => {
	return {
		FunctionList: () => {
			// console.log({ functionlist });
			return Object.keys(functionlist).map(a => {
				return { id: a, caption: a };
			});
		},
		ExecuteFunction: async (funcName, val) => {
			// console.log("1", { funcName, val });
			if (functionlist[funcName]) return await functionlist[funcName](val, funcName);
		},
	};
};

export default CustomFormatter;
